import { useEffect, useState } from "react";
import { ProductsTypes } from "../../../../api/types/products.types";
import ProductsService from "../../../../api/services/products.service";
import ProductCard from "../../../common/product-card/ProductCard";
import styles from "./DiscountedProducts.module.scss";
import { useTranslation } from "react-i18next";
import { useCurrencies } from "../../../../context/CurrenciesContext";
import { useLanguage } from "../../../../context/LanguageContext";
import { groupProductVariants } from "../../../../utils/groupProductVariants";

const DiscountedProducts = () => {
  const [products, setProducts] = useState<ProductsTypes[]>([]);
  const [loading, setLoading] = useState(false);

  const { currencyId } = useCurrencies();
  const { t } = useTranslation("translation");
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    const fetchProducts = async () => {
      if (!currencyId) return;
      setLoading(true);

      try {
        const res = await ProductsService.getAllProducts(
          1,
          10,
          Number(currencyId),
        );
        const variants = res?.data?.data || [];

        const discountedVariants = variants.filter(
          (v: ProductsTypes) => v.discount_percent && v.discount_percent > 0,
        );
        const groupedProducts = groupProductVariants(discountedVariants);

        setProducts(groupedProducts.slice(0, 5));
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [currencyId]);

  const getLocalizedName = (product: ProductsTypes) => {
    switch (currentLanguage) {
      case "az":
        return product.name_az || product.name_en;
      case "de":
        return product.name_de || product.name_en;
      case "es":
        return product.name_es || product.name_en;
      case "en":
      default:
        return product.name_en;
    }
  };

  if (loading || products.length === 0) {
    return null;
  }

  return (
    <section className={styles.discounted_section}>
      <div className="container">
        <div className={styles.header}>
          <h2 className={styles.title}>
            {t("discounted_products") || "Endirimlə məhsullar"}
          </h2>
          <a href="/products" className={styles.view_all}>
            {t("view_all") || "Hamısına bax"}
          </a>
        </div>
        <div className={styles.products_grid}>
          {products.map((p) => (
            <ProductCard
              id={p.id}
              key={p.id}
              title={getLocalizedName(p)}
              currency={p.currency_name}
              price={p.price?.toString()}
              discount_percent={p.discount_percent?.toString()}
              discount_price={p.discount_price?.toString()}
              image={p.images ? p.images[0]?.image : ""}
              stock_quantity={p.stock_quantity}
              wishlist={p.is_wish}
              images={p.images}
              attributes={p.attributes}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default DiscountedProducts;
